import styled from "styled-components";
import SectionHeaderAndContent from "../../components/SectionHeaderAndContent";
import { isValidUrl } from "../../helper";

const column = [
  {
    key: "passportNo",
    label: "Passport Number",
  },
  {
    key: "passportExpiry",
    label: "Passport Expiry",
  },
  {
    key: "paymentType",
    label: "Payment Type",
  },
  {
    key: "travelType",
    label: "Travel Class",
  },
  {
    key: "privilegeClub",
    label: "Privilege Club",
  },
  {
    key: "passportPdf",
    label: "Passport",
  },
  {
    key: "phone",
    label: "Phone",
  },
];
const ConfirmRequestGridLayout = ({ data }) => {
  const getContent = (key) => {
    if (key === "passportPdf") {
      return (
        <>
          {isValidUrl(data?.passportPdf) ? (
            <a href={data?.passportPdf}>
              <span>{`${data?.firstName.toLowerCase()}.pdf`}</span>
            </a>
          ) : (
            "Not Available"
          )}
        </>
      );
      // return column.filter((col) => col.key === 'passportPdf');
    }
    return data[key] ? data[key] : "NA";
  };
  return (
    <>
      <TravellerDetailsGrid>
        {column.map((eachData, i) => {
          return (
            <TravellerDetailsGridItem key={i}>
              <SectionHeaderAndContent
                heading={eachData.label}
                content={getContent(eachData.key)}
                headerFontWeight="500"
                contentFontSize="0.875rem"
                contentFontWeight="500"
                textTransform="capitalize"
              />
            </TravellerDetailsGridItem>
          );
        })}
      </TravellerDetailsGrid>
    </>
  );
};

export const TravellerDetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1.25rem 2.125rem;
  margin-top: 1.25rem;

  @media only screen and (max-width: 1100px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.125rem 5.813rem;
  }

  @media only screen and (max-width: 500px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.125rem 0.813rem;
  }

  @media only screen and (max-width: 380px) {
    // grid-template-columns: repeat(1, 1fr);
    // gap: 1rem 0rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
`;

export const TravellerDetailsGridItem = styled.div`
  grid-column: ${(props) => props.gridColumn && "span 2"};
  @media only screen and (max-width: 380px) {
    grid-column: none;
  }
`;

export default ConfirmRequestGridLayout;
